import * as React from 'react';
import { COLORS_CONFIG } from '../utils/tokens';

const DEFAULT_MODULE = 1;

export function useColorsConfig(moduleId = DEFAULT_MODULE) {
  const colors = React.useMemo(() => {
     return COLORS_CONFIG[moduleId] || COLORS_CONFIG[DEFAULT_MODULE];
   }, [moduleId]);

  const getColorsByModule = React.useCallback((id) => {
    return COLORS_CONFIG[id] || COLORS_CONFIG[DEFAULT_MODULE];
  }, []);

  return {
    getColorsByModule,
    colors
  };
}
